'use client';

import { Button } from '@/components/ui';
import { useSpinAllStore } from '@/stores';

type SpinAllButtonProps = {
  'data-cy'?: string;
};

export const SpinAllButton = ({ 'data-cy': dataCy }: SpinAllButtonProps) => {
  const label = useSpinAllStore((state) => state.label);
  const disabled = useSpinAllStore((state) => state.disabled);
  const onClick = useSpinAllStore((state) => state.onClick);

  return (
    <Button
      data-cy={dataCy}
      variant="tertiary"
      size="large"
      className="w-full"
      disabled={disabled}
      onClick={onClick}
    >
      {label}
    </Button>
  );
};
